import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import { Badge, Collapse, List, SvgIcon, makeStyles } from "@material-ui/core";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ChatIcon from "@material-ui/icons/Chat";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import QuestionAnswerOutlinedIcon from "@material-ui/icons/QuestionAnswerOutlined";
import AndroidIcon from "@material-ui/icons/Android";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import BarChartIcon from "@material-ui/icons/BarChart";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ContactsIcon from "@material-ui/icons/Contacts";
import TrendingUp from "@material-ui/icons/TrendingUp";
import Assessment from "@material-ui/icons/Assessment";
import Extension from "@material-ui/icons/Extension";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";


import { i18n } from "../translate/i18n";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { Can } from "../components/Can";

// Styles for icon colors
const useIconStyles = makeStyles({
  iconPurple: {
    color: "#7d12ce !important",
    "& svg": {
      fill: "#7d12ce !important",
      color: "#7d12ce !important",
      fontSize: "1.39286rem !important",
    },
  },
});

// Custom Icons
const ViewModuleIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z" />
  </SvgIcon>
);

const BuildIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M22.7 19.3l-6.4-6.4c.6-1.2.9-2.6.9-4 0-5-4-9-9-9-1.4 0-2.8.3-4 .9l3.6 3.6-2.8 2.8-3.6-3.6C.3 4.2 0 5.6 0 7c0 5 4 9 9 9 1.4 0 2.8-.3 4-.9l6.4 6.4 3.3-3.3z" />
  </SvgIcon>
);

// Ícone de Campanhas (Megafone)
const CampaignIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M18 11v2h4v-2zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61M20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4M4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9zm5.03 1.71L11 9.53v4.94l-1.97-1.18-.48-.29H4v-2h4.55zM15.5 12c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34" />
  </SvgIcon>
);

// Ícone de Agendamento (Calendário com grid)
const CalendarIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z" />
  </SvgIcon>
);

// Ícone de Landing Page (Layout)
const LandingPageIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M4 6h16v12H4zm2 2v2h12V8zm0 4v4h12v-4z" />
  </SvgIcon>
);

// Ícone de Kanban (Board)
const ViewKanbanIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2M9 17H7V7h2zm4-5h-2V7h2zm4 3h-2V7h2z" />
  </SvgIcon>
);

// Ícone de Conversas (Double Chat Bubble)
const ForumIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M15 4v7H5.17l-.59.59-.58.58V4zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1" />
  </SvgIcon>
);

// Ícone de Chatbot (Robot)
const SmartToyIcon = (props) => (
  <SvgIcon {...props} style={{ fill: '#7d12ce', color: '#7d12ce' }}>
    <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3m-2 10H6V7h12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13m7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5M8 15h8v2H8z" />
  </SvgIcon>
);

function ListItemLink(props) {
  const { icon, primary, to, className } = props;
  const iconClasses = useIconStyles();
  const location = useLocation();

  // Check if current route matches this link
  const isActive = location.pathname === to;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  return (
    <li>
      <ListItem
        button
        component={renderLink}
        className={className}
        style={{
          backgroundColor: isActive ? 'rgba(125, 18, 206, 0.08)' : 'transparent'
        }}
      >
        {icon ? (
          <ListItemIcon className={iconClasses.iconPurple}>
            {icon}
          </ListItemIcon>
        ) : null}
        <ListItemText
          primary={primary}
          primaryTypographyProps={{
            style: {
              fontSize: '0.8125rem',
              color: isActive ? '#7d12ce' : 'inherit',
              fontWeight: isActive ? 600 : 400
            }
          }}
        />
      </ListItem>
    </li>
  );
}


const MainListItems = (props) => {
  const { drawerClose } = props;
  const iconClasses = useIconStyles();
  const { whatsApps } = useContext(WhatsAppsContext);
  const { user } = useContext(AuthContext);
  const [connectionWarning, setConnectionWarning] = useState(false);
  const [openAtendimento, setOpenAtendimento] = useState(false);
  const [openAutomacao, setOpenAutomacao] = useState(false);
  const [openConfiguracoes, setOpenConfiguracoes] = useState(false);
  const [openAgendamento, setOpenAgendamento] = useState(false);
  const [openMarketing, setOpenMarketing] = useState(false);
  const [openKanban, setOpenKanban] = useState(false);
  const [openIntegracoes, setOpenIntegracoes] = useState(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (Array.isArray(whatsApps) && whatsApps.length > 0) {
        const offlineWhats = whatsApps.filter((whats) => {
          return (
            whats.status === "qrcode" ||
            whats.status === "PAIRING" ||
            whats.status === "DISCONNECTED" ||
            whats.status === "TIMEOUT" ||
            whats.status === "OPENING"
          );
        });
        if (offlineWhats.length > 0) {
          setConnectionWarning(true);
        } else {
          setConnectionWarning(false);
        }
      }
    }, 2000);
    return () => clearTimeout(delayDebounceFn);
  }, [whatsApps]);

  const checkVisible = (key) => {
    // If user.configs exists and the key is strictly false, hide it.
    // This applies to ALL users, including Admins.
    // If configs is undefined (backward compatibility), show it.
    if (user && user.configs && user.configs[key] === false) {
      return false;
    }
    return true;
  }

  return (
    <div onClick={drawerClose}>
      <ListItemLink
        to="/dashboard-performance"
        primary={i18n.t("Métricas")}
        icon={<BarChartIcon />}
      />

      <ListItem button onClick={() => setOpenAtendimento(!openAtendimento)}>
        <ListItemIcon className={iconClasses.iconPurple}>
          <WhatsAppIcon />
        </ListItemIcon>
        <ListItemText primary={i18n.t("mainDrawer.listItems.attendance")} primaryTypographyProps={{ style: { fontSize: '0.9125rem', fontWeight: 'bold' } }} />
        {openAtendimento ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openAtendimento} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {checkVisible('isTicketsEnabled') && (
            <ListItemLink
              to="/tickets"
              primary={i18n.t("mainDrawer.listItems.tickets")}
              icon={<ForumIcon />}
              className="nested-list-item"
              style={{ paddingLeft: 20 }}
            />
          )}

          {checkVisible('isContactsEnabled') && (
            <ListItemLink
              to="/contacts"
              primary={i18n.t("mainDrawer.listItems.contacts")}
              icon={<ContactPhoneOutlinedIcon />}
              className="nested-list-item"
              style={{ paddingLeft: 20 }}
            />
          )}
          {checkVisible('isQuickAnswersEnabled') && (
            <ListItemLink
              to="/quickAnswers"
              primary={i18n.t("mainDrawer.listItems.quickAnswers")}
              icon={<QuestionAnswerOutlinedIcon />}
              className="nested-list-item"
              style={{ paddingLeft: 20 }}
            />
          )}

          <ListItemLink
            to="/orders"
            primary="Pedidos"
            icon={<ShoppingCartIcon />}
            className="nested-list-item"
            style={{ paddingLeft: 20 }}
          />
        </List>
      </Collapse>

      <Can
        role={user.profile}
        perform="drawer-admin-items:view"
        yes={() => (
          <>
            <ListItem button onClick={() => setOpenAutomacao(!openAutomacao)}>
              <ListItemIcon className={iconClasses.iconPurple}>
                <AndroidIcon />
              </ListItemIcon>
              <ListItemText primary={i18n.t("mainDrawer.listItems.automation")} primaryTypographyProps={{ style: { fontSize: '0.9125rem', fontWeight: 'bold' } }} />
              {openAutomacao ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openAutomacao} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {checkVisible('isChatbotEnabled') && (
                  <ListItemLink
                    to="/chatbot"
                    primary={i18n.t("mainDrawer.listItems.chatbot")}
                    icon={<SmartToyIcon />}
                    className="nested-list-item"
                    style={{ paddingLeft: 20 }}
                  />
                )}
                <ListItemLink
                  to="/contact-schedules"
                  primary="Agendamentos"
                  icon={<EventAvailableIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
              </List>
            </Collapse>
          </>
        )}
      />



      <Can
        role={user.profile}
        perform="drawer-admin-items:view"
        yes={() => (
          <>
            <ListItem button onClick={() => setOpenConfiguracoes(!openConfiguracoes)}>
              <ListItemIcon className={iconClasses.iconPurple}>
                <SettingsOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary={i18n.t("mainDrawer.listItems.administration")} primaryTypographyProps={{ style: { fontSize: '0.9125rem', fontWeight: 'bold' } }} />
              {openConfiguracoes ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openConfiguracoes} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {checkVisible('isUsersEnabled') && (
                  <ListItemLink
                    to="/users"
                    primary={i18n.t("mainDrawer.listItems.users")}
                    icon={<PeopleAltOutlinedIcon />}
                    className="nested-list-item"
                    style={{ paddingLeft: 20 }}
                  />
                )}
                {checkVisible('isQueuesEnabled') && (
                  <ListItemLink
                    to="/queues"
                    primary={i18n.t("mainDrawer.listItems.queues")}
                    icon={<AccountTreeOutlinedIcon />}
                    className="nested-list-item"
                    style={{ paddingLeft: 20 }}
                  />
                )}
                <ListItemLink
                  to="/tags"
                  primary={i18n.t("tags.title")}
                  icon={<LocalOfferIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                {checkVisible('isSchedulesEnabled') && (
                  <ListItemLink
                    to="/schedules"
                    primary={i18n.t("schedules.title")}
                    icon={<EventAvailableIcon />}
                    className="nested-list-item"
                    style={{ paddingLeft: 20 }}
                  />
                )}
                {checkVisible('isConnectionsEnabled') && (
                  <ListItemLink
                    to="/connections"
                    primary={i18n.t("mainDrawer.listItems.connections")}
                    icon={
                      <Badge badgeContent={connectionWarning ? "!" : 0} color="error">
                        <SyncAltIcon />
                      </Badge>
                    }
                    className="nested-list-item"
                    style={{ paddingLeft: 20 }}
                  />
                )}
                {checkVisible('isSettingsEnabled') && (
                  <ListItemLink
                    to="/settings"
                    primary={i18n.t("mainDrawer.listItems.settings")}
                    icon={<SettingsOutlinedIcon />}
                    className="nested-list-item"
                    style={{ paddingLeft: 20 }}
                  />
                )}
                <ListItemLink
                  to="/products"
                  primary={i18n.t("products.title")}
                  icon={<LocalOfferIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/whatsapp-qrcode"
                  primary="QR Code WhatsApp"
                  icon={<WhatsAppIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />

              </List>
            </Collapse>

            {/* Kanban Section */}
            <ListItem button onClick={() => setOpenKanban(!openKanban)}>
              <ListItemIcon className={iconClasses.iconPurple}>
                <ViewKanbanIcon />
              </ListItemIcon>
              <ListItemText primary="Kanban" primaryTypographyProps={{ style: { fontSize: '0.9125rem', fontWeight: 'bold' } }} />
              {openKanban ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openKanban} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemLink
                  to="/kanban"
                  primary={i18n.t("kanban.management.title")}
                  icon={<ViewModuleIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/kanban/board"
                  primary={i18n.t("kanban.board.title")}
                  icon={<ViewModuleIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/kanban/reports"
                  primary="Relatórios"
                  icon={<Assessment />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
              </List>
            </Collapse>

            <ListItem button onClick={() => setOpenAgendamento(!openAgendamento)}>
              <ListItemIcon className={iconClasses.iconPurple}>
                <CalendarIcon />
              </ListItemIcon>
              <ListItemText primary={i18n.t("mainDrawer.listItems.appointments")} primaryTypographyProps={{ style: { fontSize: '0.9125rem', fontWeight: 'bold' } }} />
              {openAgendamento ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openAgendamento} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemLink
                  to="/specialties"
                  primary={i18n.t("specialties.title")}
                  icon={<ViewModuleIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/subspecialties"
                  primary={i18n.t("subSpecialties.title")}
                  icon={<BuildIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/professionals"
                  primary={i18n.t("professionals.title")}
                  icon={<PeopleAltOutlinedIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/appointments"
                  primary={i18n.t("appointments.title")}
                  icon={<EventAvailableIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/holidays"
                  primary="Feriados"
                  icon={<EventAvailableIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
              </List>
            </Collapse>

            <ListItem button onClick={() => setOpenMarketing(!openMarketing)}>
              <ListItemIcon className={iconClasses.iconPurple}>
                <TrendingUp />
              </ListItemIcon>
              <ListItemText primary="Marketing" primaryTypographyProps={{ style: { fontSize: '0.9125rem', fontWeight: 'bold' } }} />
              {openMarketing ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openMarketing} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemLink
                  to="/marketing-dashboard"
                  primary="Dashboard"
                  icon={<DashboardOutlinedIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/campaigns"
                  primary={i18n.t("campaigns.title")}
                  icon={<CampaignIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/campaign-landing-pages"
                  primary="Landing Pages"
                  icon={<LandingPageIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/campaign-leads"
                  primary="Leads"
                  icon={<ContactsIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/whatsapp-status"
                  primary="Status WhatsApp"
                  icon={<WhatsAppIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <Divider variant="inset" component="li" />
                <ListItemLink
                  to="/email-campaigns"
                  primary="Campanhas de E-mail"
                  icon={<MailOutlineIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/email-templates"
                  primary="Templates de E-mail"
                  icon={<ViewModuleIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/emails"
                  primary="Caixa de Entrada"
                  icon={<MailOutlineIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/smtp-configs"
                  primary="Config. SMTP"
                  icon={<SettingsOutlinedIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
              </List>
            </Collapse>

            {/* Menu Integrações */}
            <ListItem button onClick={() => setOpenIntegracoes(!openIntegracoes)}>
              <ListItemIcon className={iconClasses.iconPurple}>
                <Extension />
              </ListItemIcon>
              <ListItemText primary="Integrações" primaryTypographyProps={{ style: { fontSize: '0.9125rem', fontWeight: 'bold' } }} />
              {openIntegracoes ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openIntegracoes} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemLink
                  to="/integrations/wordpress"
                  primary="WordPress"
                  icon={<Extension />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/integrations/dzapy-chat"
                  primary="Dzapy-chat"
                  icon={<ChatBubbleIcon />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
                <ListItemLink
                  to="/integrations/api-dzapy"
                  primary="API Dzapy"
                  icon={<Extension />}
                  className="nested-list-item"
                  style={{ paddingLeft: 20 }}
                />
              </List>
            </Collapse>
          </>
        )}
      />
    </div>
  );
};

export default MainListItems;
